import React from 'react';

import {DuplicateTransform} from 'lab-automation/settings/RunSchemaSpecConstants';
import Col from 'ui-library/bs/Col';
import Row from 'ui-library/bs/Row';
import ErrorMessage from 'ui-library/ErrorMessage';
import FieldLabel from 'ui-library/inputs/FieldLabel';
import TextField from 'ui-library/inputs/TextField';

import {DuplicateFormErrors, updateTransformationProperties} from './TransformFormUtils';

interface DuplicateFormProps {
  transform: DuplicateTransform;
  onChange: (transform: DuplicateTransform) => void;
  formErrors: DuplicateFormErrors;
}

export default function DuplicateForm(props: DuplicateFormProps): JSX.Element {
  return (
    <Row>
      <Col md={4}>
        <TextField
          label="Column to duplicate"
          onChange={(e) => {
            props.onChange(
              updateTransformationProperties(props.transform, 'columnToDuplicate', e.target.value)
            );
          }}
          labelStyle={FieldLabel.STYLES.LABEL}
          isRequired={true}
          value={props.transform.transformationProperties?.columnToDuplicate}
          hasError={props.formErrors.columnToDuplicate}
        />

        {props.formErrors.columnToDuplicate ? <ErrorMessage error="Column name is required" /> : null}
      </Col>
      <Col md={4}>
        <TextField
          label="New column name"
          onChange={(e) => {
            props.onChange(updateTransformationProperties(props.transform, 'newColumnName', e.target.value));
          }}
          labelStyle={FieldLabel.STYLES.LABEL}
          isRequired={true}
          value={props.transform.transformationProperties?.newColumnName}
          hasError={props.formErrors.newColumnName}
        />
        {props.formErrors.newColumnName ? <ErrorMessage error="Column name is required" /> : null}
      </Col>
    </Row>
  );
}
